<template>
  <card>
    <list
      v-if="$store.state.user.sections['orders']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :staticFilters="staticFilters"
      :cardLink="cardLink"
      :isUpdate="true"
      :filters="filters"
      :isAdd="false"
      :setImport="true"
      :exportFields="exportFields"
      :itemLink="itemLink"
      :dateFilter="dateFilter"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  watch: {},
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      exportFields: {
        "Номер заказа": "order.id",
        "Дата продажи": {
          field: "transaction.created_at",
          callback: (val) => {
            try {
              if (val && typeof val == "string") {
                let date = new Date(val);
                return date.toLocaleString();
              }
              return "Нет даты";
            } catch (error) {
              return val;
            }
          },
        },
        Товар: "name",
        Баркод: "barcode",
        "Цена за 1 ед.": "price",
        "Цена с НДС за 1 ед.": "price_vat",
        "Общая цена": "price_total",
        "Общая цена с НДС": "price_vat_total",
        Количество: "quantity",
        НДС: "dealer.tax_percent",
        Дилер: "dealer.name",
        ИНН: "dealer.tin",
        Магазин: "shop.name",
        "Срок рассрочки": "transaction.month",
        "Процент рассрочки": "transaction.percent",
        Партнер: "partner.name",
        Отвественный: "user.name",
        "Номер клиента": {
          field: "client.phone",
          callback: (value) => {
            return "UZ " + value;
          },
        },
        Акция: {
          field: "discounts",
          callback: (value) => {
            let val = "";
            for (let i = 0; i < value.length; i++) {
              val += value[i].promotion_name + " ";
            }
            return val;
          },
        },
        Скидки: {
          field: "discounts",
          callback: (value) => {
            let val = "";
            for (let i = 0; i < value.length; i++) {
              val += 'Цена: '+value[i].discount_total + "; ";
            }
            return val;
          },
        },
      },
      staticFilters: [
        {
          title: "Фильтр по сроку",
          key: "month",
          default: "0",
          items: [
            {
              id: "0",
              title: "Показать все",
            },
            {
              id: "3",
              title: "3 месяца",
            },
            {
              id: "6",
              title: "6 месяцев",
            },
            {
              id: "9",
              title: "9 месяцев",
            },
            {
              id: "12",
              title: "12 месяцев",
            },
          ],
        },
      ],
      dateFilter: [
        {
          key: "from_at",
          titleKey: "from_at",
          title: "Начало даты",
        },
        {
          key: "till_at",
          titleKey: "till_at",
          title: "Конец даты",
        },
      ],
      filters: [
        {
          key: "partner",
          title: "Фильтр по партнерам",
          titleKey: "name",
          field_key: "partner",
          selectKey: "name",
        },
        {
          key: "shop",
          title: "Фильтр по торговым точкам",
          titleKey: "name",
          field_key: "shop",
          selectKey: "name",
        },
        {
          key: "organization",
          title: "Фильтр по организациям",
          titleKey: "name",
          field_key: "organization",
          selectKey: "name",
        },
      ],
      params: {},
      val: [],
      modalCreate: "business",
      fields: [],
      /** APIs */
      removeLink: "",
      cardLink: "item_order",
      itemLink: "register",
      setLink: "register",
      columns: [
        {
          key: "order",
          object: "id",
          title: "Номер заказа",
        },
        {
          key: "transaction",
          disableLink: true,
          dateTimeFormat: true,
          object: "created_at",
          title: "Дата продажи",
        },
        {
          key: "name",
          title: "Товар",
          full: true,
        },
        {
          key: "barcode",
          title: "Баркод",
        },
        {
          key: "price",
          title: "Цена за 1 ед.",
        },
        {
          key: "price_vat",
          title: "Цена с НДС за 1 ед.",
        },
        {
          key: "price_total",
          title: "Общая цена",
        },
        {
          key: "price_vat_total",
          title: "Общая цена с НДС",
        },
        {
          key: "dealer",
          disableLink: true,
          object: "tax_percent",
          title: "НДС",
        },
        {
          key: "quantity",
          title: "Количество",
        },
        {
          key: "shop",
          object: "name",
          title: "Магазин",
        },
        {
          key: "dealer",
          object: "name",
          title: "Компания",
        },
        {
          key: "dealer",
          object: "tin",
          title: "ИНН",
          disableLink: true,
        },
        {
          key: "transaction",
          object: "month",
          title: "Срок рассрочки",
          disableLink: true,
        },
        {
          key: "transaction",
          object: "percent",
          title: "Процент рассрочки",
          disableLink: true,
        },
        {
          key: "partner",
          object: "name",
          title: "Партнер",
          disableLink: true,
        },
        {
          key: "client",
          object: "phone",
          title: "Номер клиента",
          disableLink: true,
        },
        {
          key: "user",
          object: "name",
          title: "Отвественный",
          disableLink: true,
        },

        {
          disableLink: true,
          key: "discounts",
          object: "promotion_name",
          title: "Акция",
        },
        {
          disableLink: true,
          key: "discounts",
          object: "discount_total",
          title: "Скидка",
        },
        // {
        //   detail: true,
        //   // remove: true,
        // },
      ],
    };
  },
};
</script>
<style>
</style>
